module.exports = __webpack_public_path__ + "img/_ABS9852.aa4032fa.jpg";